interface SalesPulseAuditResultsProps {
  background?: 'white' | 'gray';
}

const cases = [
  {
    icon: 'ri-store-2-line',
    company: 'B2C — салонные продажи',
    metric: '+18%',
    metricLabel: 'конверсии за 3 недели',
    desc: 'После аудита изменили структуру звонков и переписок — заявки перестали теряться на первом контакте.',
  },
  {
    icon: 'ri-book-open-line',
    company: 'EdTech-компания',
    metric: '+21%',
    metricLabel: 'продаж за 1,5 месяца',
    desc: 'Внедрили рекомендации по итогам аудита: пересобрали работу с входящим потоком и скрипты продаж.',
  },
  {
    icon: 'ri-truck-line',
    company: 'Импортёр и дистрибьютор',
    metric: '+30%',
    metricLabel: 'рост объёма продаж за 8 месяцев',
    desc: 'Аудит выявил недочёты в процессах и работе команды — их устранение дало прирост объёма продаж.',
  },
];

const zones = ['Клиенты', 'Конкуренты', 'Команда', 'Система'];

export default function SalesPulseAuditResults({ background = 'gray' }: SalesPulseAuditResultsProps) {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="audit-results"
      className={`py-20 md:py-28 ${background === 'white' ? 'bg-white' : 'bg-gray-50'}`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-focus-3-line"></i>
            Авторский аудит SalesPulse
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-4">
            Результаты аудита отдела продаж
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-3xl mx-auto">
            Компании приходят с вопросом: «Почему мы тратим на маркетинг, а прибыль не растёт?» Аудит SalesPulse исследует 4 зоны — <strong>Клиенты, Конкуренты, Команда, Система</strong> — и показывает, где теряются заявки, кто тянет продажи вниз и какие процессы не работают.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
          {cases.map((item, i) => (
            <div key={i} className="bg-white rounded-xl p-6 border border-gray-100 hover:border-teal-200 transition-colors">
              <div className="w-12 h-12 bg-teal-600 rounded-xl flex items-center justify-center mb-5">
                <i className={`${item.icon} text-xl text-white`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm md:text-base mb-3">{item.company}</h3>
              <div className="flex items-baseline gap-2 mb-3">
                <span className="text-3xl md:text-4xl font-extrabold text-teal-600">{item.metric}</span>
              </div>
              <p className="text-teal-700 text-xs md:text-sm font-semibold mb-3">{item.metricLabel}</p>
              <p className="text-gray-600 text-xs md:text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 max-w-6xl mx-auto bg-white rounded-xl p-5 md:p-6 border border-gray-100">
          <div className="flex flex-wrap items-center justify-center gap-2 md:gap-3">
            <span className="text-gray-500 text-xs md:text-sm mr-1">Что проверяю в компании:</span>
            {zones.map((zone) => (
              <span key={zone} className="inline-flex items-center gap-1.5 bg-teal-50 text-teal-700 text-xs md:text-sm font-semibold px-3 py-1.5 rounded-full">
                <i className="ri-checkbox-blank-circle-fill text-[6px]"></i>
                {zone}
              </span>
            ))}
          </div>
        </div>

        <div className="text-center mt-12">
          <button
            onClick={() => scrollTo('contact')}
            className="bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Заказать аудит отдела продаж
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}